<template>
  <div>
    <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
      <div class="content">
        <section class="section--sidebar-user">
          
          <section class="section--content-sidebar section--content-sidebar-full-height">
            <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data" class="workflow-tabs">
              <input type="hidden" name="_token" :value="csrf">
              <input v-if="this.editing" type="hidden" name="_method" value="PUT">
              
              
              <div class="tab-content">
                
                <div class="row">
                  <div class="col-12">
                    <p class="tab-description mt-3 mb-2">
                      {{ __("forms.EvaluationChart.questions.questions_setting.question24.title") }}
                    </p>
                  </div>
                </div>
                
                <div class="row mb-3">
                  <div class="col-12 col-md-4">
                    <div class="form-group">
                      <label>{{__("forms.Question.title")}}</label>
                      <input type="text" class="form-control rounded" name="questionBase[name]" :value="name">
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="form-group">
                      <label>{{__("forms.Question.description")}}</label>
                      <input type="text" class="form-control rounded" name="questionBase[description]" :value="description">
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="form-group">
                      <label>{{__("forms.Question.sorting")}}</label>
                      <input type="number" class="form-control rounded" name="questionBase[sorting]" :value="sorting">
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="form-group">
                      <label>{{ __("forms.EvaluationChart.questions.questions_setting.question24.mode") }}</label>
                      <select class="form-control rounded" name="questionSettings[calculation]" required v-model="calculation">
                        <option value=""> --- </option>
                        <option value="matrixSummary">
                          {{ __("forms.EvaluationChart.questions.questions_setting.question24.mode_sum") }}
                        </option>
                        <option value="matrixAverage">
                          {{ __("forms.EvaluationChart.questions.questions_setting.question24.mode_avg") }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="form-group mt-4">

                      <div class="custom-control custom-switch ">
                        <input name="questionSettings[insert_zero_in_avg]" type="checkbox" class="custom-control-input"
                               id="questionSettings[insert_zero_in_avg]" value="1" v-model="insertZeroInAvg">
                        <label class="custom-control-label"
                               for="questionSettings[insert_zero_in_avg]">{{
                            __("forms.EvaluationChart.questions.questions_setting.question24.insert_zero_in_avg")
                          }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                
                
                
                <div class="row">
                  <div class="col-12">
                    <p class="tab-description mt-3 mb-2">
                      {{ __("forms.EvaluationChart.questions.questions_setting.question24.questions") }}
                    </p>
                  </div>
                </div>
                
                <div class="row mb-3">
                  <div class="col-12">
                    <div class="row align-items-center mb-3" v-for="(question,index) in questions" :key="'domande_' + index">
                      <div class="col-3">
                        <label>
                          {{ __("forms.EvaluationChart.questions.questions_setting.question24.question") }}
                        </label>
                        <input class="form-control rounded" type="text" :name="'questionSettings[questions]['+index+']'" required v-model="question.label">
                      </div>
                      <div class="col-3">
                        <button type="button" class="btn btn--only-icon-rounded btn--danger float-right" @click="deleteQuestion(index)"><i class="fas fa-times"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="row">
                  <div class="col-12">
                    <p class="tab-description mt-3 mb-2">
                      {{ __("forms.EvaluationChart.questions.questions_setting.question24.add_new_question") }}
                    </p>
                  </div>
                </div>
                
                <div class="row align-items-end">
                  <div class="col-3">
                    <label>
                      {{ __("forms.EvaluationChart.questions.questions_setting.question24.new_question") }}
                    </label>
                    <input class="form-control rounded" type="text" v-model="newQuestion">
                  </div>
                  <div class="col-3">
                    <button type="button" class="btn float-right" @click="addQuestion()">
                      {{ __("forms.EvaluationChart.questions.questions_setting.question24.add_question") }}
                    </button>
                  </div>
                </div>
                
                
                <div class="row mt-5">
                  <div class="col-12">
                    <p class="tab-description mt-3 mb-2">
                      {{ __("forms.EvaluationChart.questions.questions_setting.question24.answers") }}
                    </p>
                  </div>
                </div>
                
                <div class="row">
                  <div class="col-12">
                    <div class="row mb-3" v-for="(row,index) in answers" :key="'ans_' + index">
                      <div class="col-3">
                        <label>
                          {{ __("forms.EvaluationChart.questions.questions_setting.question24.value") }}
                        </label>
                        <input class="form-control rounded" type="number" step=".01" :name="'questionSettings[answers]['+index+'][value]'" required v-model="row.value">
                      </div>
                      
                      <div class="col-3">
                        <label>{{ __("forms.EvaluationChart.questions.questions_setting.question24.label") }}</label>
                        <input class="form-control rounded" type="text" :name="'questionSettings[answers]['+index+'][label]'" required v-model="row.label">
                      </div>
                      <div class="col-3">
                        <label>{{
                            __("forms.EvaluationChart.questions.questions_setting.question24.description")
                          }}</label>
                        <input class="form-control rounded" type="text" :name="'questionSettings[answers]['+index+'][declaration]'" required v-model="row.declaration">
                      </div>
                      <div class="col-3">
                        <button type="button" class="btn btn--only-icon-rounded btn--danger float-right" @click="deleteAnswers(index)"><i class="fas fa-times"></i></button>
                      </div>
                      
                    </div>
                  </div>
                </div>
                
                <div class="row mt-5">
                  <div class="col-12">
                    <p class="tab-description mt-3 mb-2">
                      {{ __("forms.EvaluationChart.questions.questions_setting.question24.add_new_answer") }}
                    </p>
                  </div>
                </div>
                
                <div class="row align-items-end">
                  <div class="col-3">
                    <label>
                      {{ __("forms.EvaluationChart.questions.questions_setting.question24.value") }}
                    </label>
                    <input class="form-control rounded" type="number" v-model="newAnswerValue">
                  </div>
                  <div class="col-3">
                    <label>{{ __("forms.EvaluationChart.questions.questions_setting.question24.label") }}</label>
                    <input class="form-control rounded" type="text" v-model="newAnswerLabel">
                  </div>
                  <div class="col-3">
                    <label>{{ __("forms.EvaluationChart.questions.questions_setting.question24.description") }}</label>
                    <input class="form-control rounded" type="text" v-model="newAnswerDeclaration">
                  </div>
                  <div class="col-3">
                    <button type="button" class="btn float-right" @click="addAnswer()">
                      {{ __("forms.EvaluationChart.questions.questions_setting.question24.add_answer") }}
                    </button>
                  </div>
                </div>
                
                
                <div class="row mt-5">
                  <div class="col-12">
                    <p class="tab-description mt-3 mb-2">Rating ( se X < index => Value)</p>
                  </div>
                </div>
                
                <div class="row">
                  <div class="col-12">
                    <div class="row" v-for="(row,index) in rating" :key="'rating_' + index">
                      <div class="col-3">
                        <label>{{ __("forms.EvaluationChart.questions.questions_setting.question24.index") }}</label>
                        <input class="form-control rounded" :name="'questionSettings[rating]['+index+'][index]'" required :value="row.index">
                      </div>
                      <div class="col-3">
                        <label>{{ __("forms.EvaluationChart.questions.questions_setting.question24.outcome") }}</label>
                        <input class="form-control rounded" :name="'questionSettings[rating]['+index+'][label]'" required :value="row.label">
                      </div>
                      <div class="col-6">
                        <button type="button" class="btn btn--only-icon-rounded btn--danger float-right" @click="deleteRating(index)"><i class="fas fa-times"></i></button>
                      </div>
                      
                    </div>
                  </div>
                </div>

                <div class="row mt-5">
                  <div class="col-12">
                    <p class="tab-description mt-3 mb-2">
                      {{ __("forms.EvaluationChart.questions.questions_setting.question24.add_rating") }}
                    </p>
                  </div>
                </div>
                
                <div class="row mb-3">
                  <div class="col-3">
                    <label>{{ __("forms.EvaluationChart.questions.questions_setting.question24.index") }}</label>
                      <input class="form-control rounded" type="number" v-model="newRatingIndex" >
                  </div>
                  <div class="col-3">
                    <label>{{ __("forms.EvaluationChart.questions.questions_setting.question24.label") }}</label>
                      <input class="form-control rounded" type="text" v-model="newRatingLabel" >
                  </div>
                  <div class="col-6">
                    <button type="button" class="btn float-right" @click="addRating()">
                      {{ __("misc.add") }}
                      </button>
                  </div>
                </div>
                
                <div class="row">
                  <div class="col-12">
                    <hr>
                  </div>
                  <div class="col-12 mt-3 text-right" v-if="can_write">
                    <button class="btn btn-next" type="submit">{{ __('misc.save') }}</button>
                  </div>
                </div>
                
              </div>
            </form>
          </section>
        </section>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  props: {
    can_write:{
      type:Boolean,
      required:true,
    }
  },
  data () {
    return {
      newQuestion : "",
      newRatingLabel : "",
      newRatingIndex : 0,
      newAnswerValue : 0,
      insertZeroInAvg: 0,
      newAnswerLabel : "",
      newAnswerDeclaration : "",             
      questions : [],
      answers : [],
      calculation : [],
      rating : [],
      title: "Matrix Calculation",
      active : false,
      action : "",
      name:"",
      description:"",
      sorting:-1,
      editing : true,
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }
  },
  methods: {
    deleteRating(rowIndex){
      Vue.delete(this.rating,rowIndex);
    },
    deleteQuestion(rowIndex){
      Vue.delete(this.questions,rowIndex);
    },
    deleteAnswers(rowIndex){
      Vue.delete(this.answers,rowIndex);
    },
    addRating(){
      let row = {
        index : this.newRatingIndex,
        label : this.newRatingLabel
      };
      this.rating.push(row);
      this.newRatingIndex = 0;
      this.newRatingLabel = "";
    },
    addAnswer(){
      
      let row = {
        value : this.newAnswerValue,
        label : this.newAnswerLabel,
        declaration : this.newAnswerDeclaration
      };
      this.answers.push(row);
      
      this.newAnswerValue = 0;
      this.newAnswerLabel = "";
      this.newAnswerDeclaration = "";
    },
    addQuestion(){
      
      let row = {
        label : this.newQuestion,
      };
      this.questions.push(row);
      this.newQuestion = "";
    },
    toggle(action, item_id, editing, attributes) {
      this.active     = true;
      this.action     = action;
      this.editing    = editing;
      
      let dataRoute   = decodeURI(attributes.dataRoute);
      if (dataRoute!==undefined) {
        if (dataRoute.indexOf("[id]")>0) {
          dataRoute = dataRoute.replace("[id]", item_id);
          
        }
        axios.get(dataRoute)
        .then((response) => {
          this.name = response.data.base.name;
          this.description = response.data.base.description;
          this.sorting = response.data.base.sorting;
          this.questions = response.data.questions;
          this.answers = response.data.answers;
          this.calculation = response.data.calculation;
          this.rating = response.data.rating;
          this.insertZeroInAvg = response.data.insert_zero_in_avg;
          this.can_write = app.__vue__.questionPermission(this.can_write, response.data.base.enable);
        });
      }
    }
  }
}
</script>

